module.exports = __webpack_public_path__ + "static/media/profile-settings-avatar.8b023576.png";